import { ResponsiveLine, Serie, SliceTooltip } from '@nivo/line';
import moment from 'moment';
import { min } from 'lodash';
import { DatumValue } from '@nivo/core';
import useChartTheme from './chartTheme';

type Props = {
  data: Serie[];
  tooltip: SliceTooltip;
  yFormat: (value: DatumValue) => string;
  curve?:
    | 'basis'
    | 'cardinal'
    | 'catmullRom'
    | 'linear'
    | 'monotoneX'
    | 'monotoneY'
    | 'natural'
    | 'step'
    | 'stepAfter'
    | 'stepBefore';
  xMin?: string;
  xMax?: string;
};

export default function Linha({
  data,
  tooltip,
  yFormat,
  curve = 'linear',
  xMin,
  xMax,
}: Props) {
  const chartTheme = useChartTheme();
  return (
    <ResponsiveLine
      data={data}
      theme={chartTheme}
      colors={{ datum: 'color' }}
      margin={{ top: 8, right: 16, bottom: 64, left: 64 }}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
        useUTC: false,
        precision: 'day',
        min: xMin,
        max: xMax,
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false,
        nice: 5,
        clamp: true,
      }}
      yFormat={yFormat}
      curve={curve}
      axisTop={null}
      axisRight={null}
      axisLeft={{
        tickValues: 5,
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: -40,
        legendPosition: 'middle',
        format: yFormat,
      }}
      axisBottom={{
        tickValues: min([6, data[0]?.data.length]),
        format: (d) => {
          return moment(d).format('MMM/YY');
        },
      }}
      gridYValues={5}
      enablePoints={false}
      enableArea={false}
      useMesh={true}
      enableSlices="x"
      enableGridY={true}
      enableGridX={false}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 64,
          itemsSpacing: 20,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 1,
          symbolSize: 12,
          symbolShape: 'circle',
        },
      ]}
      sliceTooltip={tooltip}
    />
  );
}
